"use client";

import React from "react";
import { CircleAlert, TrendingDown, Users, Clock, CircleCheck, ShieldCheck, ArrowRight, Target } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const painPoints = [{
  title: "Postezi pe social media dar nu vin clienți",
  description: "Crezi conținut constant, dar reach-ul scade și interacțiunile nu se transformă în vânzări reale.",
  icon: CircleAlert
}, {
  title: "Nu știi ce tip de conținut să faci",
  description: "Setezi campanii care consumă bani zilnic, dar costul per achiziție este prea mare pentru a fi profitabil.",
  icon: TrendingDown
}, {
  title: "Reclamele îți consumă bugetul fără rezultate",
  description: "Vezi cum alții din nișa ta cresc accelerat, deși produsul sau serviciul tău este superior calitativ.",
  icon: Users
}, {
  title: "Nu ai timp să înveți marketingul singur",
  description: "Încerci tactici care funcționau acum 2 ani, dar piața s-a schimbat și ai nevoie de un sistem actualizat.",
  icon: Clock
}];
const solutionBenefits = ["Framework pas-cu-pas pentru conversie maximă", "Șabloane și scripturi gata de implementat imediat", "Sistem predictibil de generare a lead-urilor"];
export default function AudienceProblem() {
  const {
    ref: painRef,
    isVisible: isPainVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: solutionRef,
    isVisible: isSolutionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="problemapublicului" className="w-full py-20 overflow-hidden bg-black text-white md:py-32 animate-fade-in-up motion-reduce:animate-none">
      <div className="container max-w-6xl">
        
        <div ref={painRef} className={`mb-24 text-center transition-all duration-1000 transform ${isPainVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl md:text-6xl font-montserrat font-bold mb-6 tracking-tight text-white">
              Problema&nbsp;<span className="!text-[hsl(0,74%,42%)]">publicului</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {painPoints.map((point, i) => <Card key={i} data-index={i} className="card group transition-all duration-300 hover:shadow-primary-500/20 text-left">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors !text-[hsl(0,70%,35%)] !bg-[hsl(0,74%,42%)]">
                    <point.icon className="size-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-bold">{point.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">{point.description}</p>
                </CardContent>
              </Card>)}
          </div>

          <div className="mt-16 text-center">
            <p className="text-xl font-medium text-primary-100">Dacă te regăsești în aceste situații, acest curs este pentru tine.</p>
          </div>
        </div>
      </div>

      <div ref={solutionRef} className={`hero-bg w-full py-20 relative overflow-hidden animate-fade-in-up motion-reduce:animate-none transition-all duration-1000 delay-200 transform ${isSolutionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-primary/20 via-transparent to-transparent opacity-60 mix-blend-overlay pointer-events-none"></div>
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-20 pointer-events-none"></div>

          <div className="container max-w-6xl relative z-10 grid gap-12 items-center">
            
            <div className="text-white space-y-8 text-center flex flex-col items-center">
              <div>
                <h2 className="text-4xl md:text-6xl font-montserrat font-bold leading-tight mb-6">Soluția</h2>
                <div className="text-lg text-white/80 leading-relaxed max-w-3xl space-y-4">
                  <p>Am creat un curs de marketing pentru antreprenori în care înveți exact ce trebuie să faci pentru a atrage clienți online.</p>
                  <p>Nu este un curs plin de teorie. Este un sistem testat în agenția noastră pe zeci de business-uri.</p>
                </div>
              </div>

              <div className="pt-4">
                <Link to="#oportunitate-bonus" className="btn h-14 px-10 text-lg rounded-full shadow-lg !border-[hsl(0,0%,100%)] !border-1 border-solid !bg-transparent !bg-none">Vreau să aflu mai multe</Link>
              </div>
            </div>

            <div className="relative">
            </div>

          </div>
        </div>
    </section>;
}